import MarginGroup from 'app/components/layout/MarginGroup';
import React from 'react';
import BlockedStreamsErrorMessage from 'app/components/call/CallErrors/BlockedStreamsErrorMessage';
import DeviceManagerErrorMessage from 'app/components/call/CallErrors/DeviceManagerErrorMessage';
import NavigationErrorMessage from 'app/components/call/CallErrors/NavigationErrorMessage';
import PeerTimeoutWarnings from 'app/components/call/CallErrors/PeerTimeoutWarnings';
import PlaybackErrorMessage from 'app/components/call/CallErrors/PlaybackErrorMessage';
import SignalingErrorMessage from 'app/components/call/CallErrors/SignalingErrorMessage';
import UnsupportedErrorMessage from 'app/components/call/CallErrors/UnsupportedErrorMessage';
import ParticipantCountErrorMessage from 'app/components/call/CallErrors/ParticipantCountErrorMessage';

const CallErrors = () => (
  <MarginGroup margin={'2px'}>
    <UnsupportedErrorMessage />
    <SignalingErrorMessage />
    <NavigationErrorMessage />
    <PlaybackErrorMessage />
    <DeviceManagerErrorMessage />
    <BlockedStreamsErrorMessage />
    <ParticipantCountErrorMessage />
    <PeerTimeoutWarnings />
  </MarginGroup>
);

export default CallErrors;
